import React from 'react';
import i18n from '../../i18n';
import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import CardActions from "@material-ui/core/CardActions/CardActions";
import {withStyles} from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip/Chip";
import {FormattedDate} from "react-intl";
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Divider from "@material-ui/core/Divider/Divider";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";
import DeleteButton from "../Form/DeleteButton";

class PersonsGrid extends React.Component {
    render() {
        const {persons, classes} = this.props;

        return (
            <section>
                <Grid container spacing={16}>
                    {persons.map(person => {

                        let fullname = person.first_name ? person.first_name + ' ' + person.last_name : person.last_name;

                        fullname = person.title ? fullname + ', ' + person.title : fullname;

                        return (
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={person.id}>
                                <Card key={person.id}>
                                    <a href={`/persons/${person.person_type}/${person.id}`} style={{textDecoration: 'none'}}>
                                        <CardContent className={classes.cardContent}>
                                            <Grid container spacing={8} justify="space-between" alignItems="center">
                                                <Grid item xs={12} sm={person.is_craft && person.department ? 7 : 12}>
                                                        <Typography variant="h6" component="h2">
                                                            <EllipisWithTooltip>{fullname}</EllipisWithTooltip>
                                                        </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={5}>
                                                    <Grid container justify="flex-end">
                                                        <Grid item>
                                                            {person.is_craft && person.department && (
                                                                <Chip color="primary" variant="outlined"
                                                                      label={person.department}
                                                                      classes={{root: classes.chip, label: classes.chipLabel}}/>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {person.board && (
                                                <Typography component='div'>
                                                    <EllipisWithTooltip>{person.board.board_name}</EllipisWithTooltip>
                                                </Typography>
                                            )}

                                            {person.street && (
                                                <Typography>
                                                    <span>
                                                        {person.street} {person.housenumber || ''} <br/>
                                                        {person.zip || ''} {person.city || ''}
                                                    </span>
                                                </Typography>
                                            )}

                                            {! person.is_craft && person.tenant_since && (
                                                <Typography>
                                                    <br/>
                                                    {i18n.get('persons.tenant_since')}&nbsp;
                                                    <FormattedDate value={new Date(person.tenant_since)}/>
                                                </Typography>
                                            )}

                                        </CardContent>
                                    </a>

                                    <Divider />

                                    <CardActions className={classes.cardActions}>
                                        <Grid container justify="space-between" alignItems="center">
                                            <Grid item>
                                                {person.email && (
                                                    <Tooltip placement="bottom-start" title={person.email} classes={{tooltip : classes.popper}}>
                                                        <IconButton href={`mailto:${person.email}`} className={classes.iconButton}>
                                                            <Icon className={classes.iconButtonIcon}>alternate_email</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {person.telephone && (
                                                    <Tooltip placement="bottom-start" title={person.telephone} classes={{tooltip : classes.popper}}>
                                                        <IconButton href={`tel:${person.telephone}`} className={classes.iconButton}>
                                                            <Icon className={classes.iconButtonIcon}>phone</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </Grid>

                                            <Grid item>
                                                {/*<Tooltip placement="bottom-end" title={i18n.get('persons.delete')} classes={{tooltip : classes.popper}}>*/}
                                                    {/*<IconButton href={`persons/${person.id}`} className={classes.iconButton}>*/}
                                                        {/*<Icon className={classes.iconButtonIcon}>delete</Icon>*/}
                                                    {/*</IconButton>*/}
                                                {/*</Tooltip>*/}

                                                <Tooltip placement="bottom-end" title={i18n.get('persons.edit')} classes={{tooltip : classes.popper}}>
                                                    <IconButton href={`/persons/${person.person_type}/${person.id}/edit`} className={classes.iconButton}>
                                                        <Icon className={classes.iconButtonIcon}>edit</Icon>
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip placement="bottom-end" title={i18n.get('persons.show_more')} classes={{tooltip : classes.popper}}>
                                                    <IconButton href={`/persons/${person.person_type}/${person.id}`} className={classes.iconButton}>
                                                        <Icon className={classes.iconButtonIcon}>arrow_forward</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </CardActions>
                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>
            </section>
        )
    }
}

const styles = theme => ({
    cardContent: {
        minHeight: '175px'
    },
    cardActions: {
        padding: '4px 8px',
    },
    chip: {
        height: '24px',
    },
    chipLabel: {
        padding: '0 8px'
    },
    iconButton: {
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1
        }
    },
    iconButtonIcon: {
        fontSize: 20
    },
    popper: {
        fontSize: 14,
        boxShadow: '2px 2px 3px rgba(0,0,0,0.3)'
    },
});

export default withStyles(styles)(PersonsGrid);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Contracts/ContractGrid.js